import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';

import { AppConfigService } from './core/config/app-config.service';
import { PwaUpdateService } from './core/services/pwa-update.service';
import { SessionService } from './core/services/session.service';

@Component({
  selector: 'app-root',
  imports: [IonApp, IonRouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  constructor() {
    inject(PwaUpdateService).initialize();

    const session = inject(SessionService);
    const appConfig = inject(AppConfigService);

    // Startup read of the backend app configuration (`MOBILE`/`MaxQty` and anything added later).
    // Anchored on the session rather than an APP_INITIALIZER because the feed is authenticated and
    // tenant-scoped: this fires on every authenticated boot — a PWA relaunch that restores a stored
    // session as well as a fresh sign-in — and resets to the built-in defaults on logout/expiry.
    effect(() => {
      if (session.isAuthenticated()) {
        void appConfig.ensureLoaded();
      } else {
        appConfig.clear();
      }
    });
  }
}
